import { useCallback } from "react";

import { ClientGateway } from "@kex/api";
import { useIntl } from "react-intl";

import {
  type RequisitesDetailsAccount,
  getRequisitesDetailsMessages,
} from "./get-requisites-details-messages";

export const useBankAccountDetails = (
  clientType: ClientGateway.ClientTypesEnum,
) => {
  const { formatMessage } = useIntl();

  return useCallback(
    (account: RequisitesDetailsAccount) => {
      const messages = getRequisitesDetailsMessages(clientType, account);
      return messages
        .map((line) => formatMessage(line.descriptor, line.values))
        .join("\n");
    },
    [clientType, formatMessage],
  );
};
